import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Button, Field } from 'components/elements'
import SearchFilterPopUp from '../searchTippyPopup/searchTippyPopUp'
import YearInput from '../filterInputs/yearInput.js'
import EngineInput from '../filterInputs/engineInput.js'
import QueryString from 'query-string'
import { buildTheQueryString, removeFromUrlPush } from '../filterUtil.js'
import {
  isYearRangeDefault,
  YEAR_FILTER_SHORT_NAME,
  yearDefault,
} from './yearsFilterConfig'
import {
  PAGE_FILTER_SHORT_NAME
} from '../pagination/paginationFilterConfig'
import {
  MAX_DISTANCE_FILTER_SHORT_NAME,
  MIN_DISTANCE_FILTER_SHORT_NAME,
  maxDistanceDefault,
  distanceOptions,
  minDistanceDefault,
} from './distanceFilterConfig'
import {
  priceDefault,
  PRICE_FILTER_SHORT_NAME,
  isPriceRangeDefault,
} from '../price/priceFilterConfig'
import PriceInput from "../filterInputs/priceInput";
import {
  IS_BIKE_FOR_SALE_FILTER_SHORT_NAME,
  isBikeForSaleDefault,
} from './isBikeForSaleFilterConfig'
import { 
  NEWLY_LISTED_FILTER_SHORT_NAME,
  newlyListedDefault,
} from './newlyListedConfig'
import {
  TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME,
  twentyPointInspectedDefault
} from './twentyPointInspected'
import './../../../theme/assets/styles/updated.sass'
import {
  engineDefault,
  ENGINE_FILTER_SHORT_NAME,
  isEngineRangeDefault
} from './engineFilterConfig'
import {
  seatDefault,
  SEAT_FILTER_SHORT_NAME,
  isSeatRangeDefault
} from './seatFilterConfig'
import SeatInput from '../filterInputs/seatInput'

let classNames = require('classnames')

class MoreFilters extends Component {
  constructor(props) {
    super(props)
    this.state = {
      disableApplyBtn: true,
      open: false,
      buttonLabel: this.props.defaultLabel,
      currentYears: [
        Number(this.props.currentYears[0]),
        Number(this.props.currentYears[1]),
      ],
      currentEngines: [
        Number(this.props.currentEngines[0]),
        Number(this.props.currentEngines[1]),
      ],
      currentPriceRange: [
        Number(this.props.currentPriceRange[0]),
        Number(this.props.currentPriceRange[1]),
      ],
      currentSeatRange: [
        Number(this.props.currentSeatRange[0]),
        Number(this.props.currentSeatRange[1]),
      ],
      distance: this.props.distance,
      newlyListed: this.props.newlyListed,
      isBikeForSale: this.props.isBikeForSale,
      active: false,
      activeCount: 0,
      isNewlyListedChecked: false,
      twentyPointInspected: false,
    }
  }

  componentDidMount() {
    //we might grab the URL here on mount. but I don't know if we should or not.
    //might pass these down as defaultValue props.
    this.handleApply(true)
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.currentYears !== this.props.currentYears ||
      prevProps.currentEngines !== this.props.currentEngines ||
      prevProps.currentPriceRange !== this.props.currentPriceRange ||
      prevProps.currentSeatRange !== this.props.currentSeatRange ||
      prevProps.distance !== this.props.distance ||
      prevProps.newlyListed !== this.props.newlyListed ||
      prevProps.twentyPointInspected !== this.props.twentyPointInspected ||
      prevProps.isBikeForSale !== this.props.isBikeForSale
    ) {
      const activeCheck = this.isMoreActive({
        distance: this.props.distance,
        currentYears: this.props.currentYears,
        currentEngines: this.props.currentEngines,
        currentPriceRange: this.props.currentPriceRange,
        currentSeatRange: this.props.currentSeatRange,
        newlyListed: this.props.newlyListed,
        twentyPointInspected: this.props.twentyPointInspected,
        isBikeForSale: this.props.isBikeForSale,
      })
      const { isActive, activeCount } = activeCheck
      this.setState({
        currentYears: this.props.currentYears,
        distance: this.props.distance,
        currentPriceRange: this.props.currentPriceRange,
        currentEngines: this.props.currentEngines,
        currentSeatRange: this.props.currentSeatRange,
        newlyListed: this.props.newlyListed,
        twentyPointInspected: this.props.twentyPointInspected,
        isBikeForSale: this.props.isBikeForSale,
        activeCount: activeCount,
      })

      this.setButton(isActive, activeCount)
    }
  }

  moreActive = () => {
    return this.isMoreActive({
      distance: this.state.distance,
      currentPriceRange: this.state.currentPriceRange,
      currentYears: this.state.currentYears,
      currentEngines: this.state.currentEngines,
      currentSeatRange: this.state.currentSeatRange,
      newlyListed: this.state.newlyListed,
      twentyPointInspected: this.state.twentyPointInspected,
      isBikeForSale: this.state.isBikeForSale,
    })
  }

  handleApply = (activeCheckOnly) => {
    const activeCheck = this.moreActive()

    const { isActive, activeCount, activeFilters } = activeCheck
    this.setState({ activeCount: activeCount })

    this.setButton(isActive, activeCount)

    if (activeCheckOnly === true) {
      return false
    }

    let valuesObject = {}

    valuesObject[YEAR_FILTER_SHORT_NAME] = this.state.currentYears
    valuesObject[ENGINE_FILTER_SHORT_NAME] = this.state.currentEngines
    valuesObject[PRICE_FILTER_SHORT_NAME] = this.state.currentPriceRange
    valuesObject[SEAT_FILTER_SHORT_NAME] = this.state.currentSeatRange
    valuesObject[MIN_DISTANCE_FILTER_SHORT_NAME] = minDistanceDefault
    valuesObject[MAX_DISTANCE_FILTER_SHORT_NAME] = this.state.distance
    valuesObject[NEWLY_LISTED_FILTER_SHORT_NAME] = this.state.newlyListed
    valuesObject[TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME] = this.state.twentyPointInspected
    valuesObject[IS_BIKE_FOR_SALE_FILTER_SHORT_NAME] = this.state.isBikeForSale

    this.closeFilter()

    //we do have some of these functions in other functions but we use them natively here.
    let parsedURLParams = QueryString.parse(this.props.location.search) //using the util function here instead of within filterUtil.js

    //if we have distance
    if (activeFilters.includes(MAX_DISTANCE_FILTER_SHORT_NAME)) {
      parsedURLParams[MIN_DISTANCE_FILTER_SHORT_NAME] = minDistanceDefault
      parsedURLParams[MAX_DISTANCE_FILTER_SHORT_NAME] = this.state.distance
    } else {
      delete parsedURLParams[MAX_DISTANCE_FILTER_SHORT_NAME]
      delete parsedURLParams[MIN_DISTANCE_FILTER_SHORT_NAME]
    }

    //if we have price
    if (activeFilters.includes(PRICE_FILTER_SHORT_NAME)) {
      parsedURLParams[PRICE_FILTER_SHORT_NAME] = this.state.currentPriceRange
    } else {
      delete parsedURLParams[PRICE_FILTER_SHORT_NAME]
    }

    //if we have years
    if (activeFilters.includes(YEAR_FILTER_SHORT_NAME)) {
      parsedURLParams[YEAR_FILTER_SHORT_NAME] = this.state.currentYears
    } else {
      delete parsedURLParams[YEAR_FILTER_SHORT_NAME]
    }

    //if we have engines
    if (activeFilters.includes(ENGINE_FILTER_SHORT_NAME)) {
      parsedURLParams[ENGINE_FILTER_SHORT_NAME] = this.state.currentEngines
    } else {
      delete parsedURLParams[ENGINE_FILTER_SHORT_NAME]
    }

    //if we have seats
    if (activeFilters.includes(SEAT_FILTER_SHORT_NAME)) {
      parsedURLParams[SEAT_FILTER_SHORT_NAME] = this.state.currentSeatRange
    } else {
      delete parsedURLParams[SEAT_FILTER_SHORT_NAME]
    }

    //if we have newly listed
    if (activeFilters.includes(NEWLY_LISTED_FILTER_SHORT_NAME)) {
      parsedURLParams[NEWLY_LISTED_FILTER_SHORT_NAME] = this.state.newlyListed
    } else {
      delete parsedURLParams[NEWLY_LISTED_FILTER_SHORT_NAME]
    }

    //if we have 20-point inspected
    if (activeFilters.includes(TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME)) {
      parsedURLParams[TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME] = this.state.twentyPointInspected
    } else {
      delete parsedURLParams[TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME]
    }

    //if we have bike for sale
    if (activeFilters.includes(IS_BIKE_FOR_SALE_FILTER_SHORT_NAME)) {
      parsedURLParams[
        IS_BIKE_FOR_SALE_FILTER_SHORT_NAME
      ] = this.state.isBikeForSale
    } else {
      delete parsedURLParams[IS_BIKE_FOR_SALE_FILTER_SHORT_NAME]
    }

    let newQueryString = buildTheQueryString(parsedURLParams)

    if (newQueryString?.includes('&page=')) {
      const { string } = removeFromUrlPush(
        [PAGE_FILTER_SHORT_NAME],
        newQueryString
      )
      newQueryString = string
    }

    this.props.history.push('?' + newQueryString)
    this.props.onApply(valuesObject)
  }

  handleOpen = () => {
    this.setState({ open: true })
    this.props.onOpen()
  }

  closeFilter = () => {
    this.setState({ open: false })
    this.props.onClose()
  }

  handleYearChange = (values) => {
    this.setState({
      currentYears: values,
      disableApplyBtn: false
    })
  }

  handleEngineChange = (values) => {
    this.setState({
      currentEngines: values,
      disableApplyBtn: false
    })
  }

  handleSeatChange = (values) => {
    this.setState({
      currentSeatRange: values,
      disableApplyBtn: false
    })
  }

  handlePriceChange = (values) => {
    this.setState({
      currentPriceRange: values,
      disableApplyBtn: false
    })
  }

  handleDistanceChange = (value) => {
    this.setState({
      distance: value,
      disableApplyBtn: false
    })
  }

  handleNewlyListed = (checked) => {
    this.setState({
      newlyListed: checked,
      disableApplyBtn: false
    })
  }

  handleTwentyPointInspected= (checked) => {
    this.setState({
      twentyPointInspected: checked,
      disableApplyBtn: false
    })
  }

  handleIsBikeForSale = (checked) => {
    this.setState({
      isBikeForSale: checked,
      disableApplyBtn: false
    })
  }

  setButton = (isActive, activeCount) => {
    if (isActive) {
      this.setState({
        active: true,
        buttonLabel: this.props.defaultLabel + ' · ' + activeCount,
      })
    } else {
      this.setState({ active: false, buttonLabel: this.props.defaultLabel })
    }
  }

  isMoreActive = (filters) => {
    let moreCount = 0

    let activeFilters = []
    if (!isYearRangeDefault(filters.currentYears)) {
      moreCount++
      activeFilters.push(YEAR_FILTER_SHORT_NAME)
    }

    if (!isEngineRangeDefault(filters.currentEngines)) {
      moreCount++
      activeFilters.push(ENGINE_FILTER_SHORT_NAME)
    }

    if (!isSeatRangeDefault(filters.currentSeatRange)) {
      moreCount++
      activeFilters.push(SEAT_FILTER_SHORT_NAME)
    }

    if (!isPriceRangeDefault(filters.currentPriceRange)) {
      moreCount++
      activeFilters.push(PRICE_FILTER_SHORT_NAME)
    }

    if (filters.newlyListed !== newlyListedDefault) {
      moreCount++
      activeFilters.push(NEWLY_LISTED_FILTER_SHORT_NAME)
    }

    if (filters.twentyPointInspected !== twentyPointInspectedDefault) {
      moreCount++
      activeFilters.push(TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME)
    }

    if (filters.distance !== maxDistanceDefault) {
      moreCount++
      activeFilters.push(MAX_DISTANCE_FILTER_SHORT_NAME)
    }

    if (filters.isBikeForSale !== false) {
      moreCount++
      activeFilters.push(IS_BIKE_FOR_SALE_FILTER_SHORT_NAME)
    }

    if (moreCount > 0) {
      return {
        isActive: true,
        activeCount: moreCount,
        activeFilters: activeFilters,
      }
    } else {
      return { isActive: false, activeCount: 0, activeFilters: activeFilters }
    }
  }

  render() {
    const {
      open,
      buttonLabel,
      currentYears,
      distance,
      isBikeForSale,
      activeCount,
      newlyListed,
      twentyPointInspected,
      currentPriceRange,
      currentSeatRange,
      currentEngines,
      disableApplyBtn
    } = this.state
    const {
      showDistanceFilter,
      showPriceFilter,
      showBikeForSale,
      showYearsFilter ,
      showEngineFilter,
      showSeatFilter,
      showTwentyPointInspected,
      showNewlyListed,
      showFooterMessage,
    } = this.props


    let filterBtnClass = classNames(
      activeCount > 0
        ? 'filterBtnClass is-primary'
        : 'filterBtnClass is-primary-non-active',
      this.props.className
    )

    return (
      <SearchFilterPopUp
        triggerClassName={filterBtnClass}
        triggerText={
          <>
            <span className="icon">
              <i className="fas fa-sliders-h"></i>
            </span>{' '}
            <span>{buttonLabel}</span>
            <span className="icon mt-1">
                &nbsp;<i className="fa fa-angle-down"></i>
            </span>
          </>
        }
        on="click"
        open={open}
        onClose={() => this.closeFilter()}
        onOpen={() => this.handleOpen()}
      >
        <>
          <div className="search-filter-inner-wrapper more-filters-wrapper">
            {showDistanceFilter && (
              <>
                <h2 className="is-size-6 mb-2 has-text-weight-extra-bold">
                  Distance
                </h2>
                <Field
                  type="select"
                  id="distance"
                  name="distance"
                  showErrors={false}
                  fullwidth
                  value={distance}
                  onChange={({ value }) => this.handleDistanceChange(value)}
                  options={distanceOptions}
                />
              </>
            )}
            {showPriceFilter && (
              <>
                <h2 className="is-size-6 mb-2 has-text-weight-extra-bold">Price</h2>
                <PriceInput
                  currentRange={currentPriceRange}
                  onChange={this.handlePriceChange}
                />
              </>
            )}
            {showSeatFilter && (
              <>
                <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                  Seat Height
                </h2>
                <SeatInput
                  currentRange={currentSeatRange}
                  onChange={this.handleSeatChange}
                />
              </>
            )}
            {showEngineFilter && (
              <>
                <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                  Engine Size
                </h2>
                <EngineInput
                  currentRange={currentEngines}
                  onChange={this.handleEngineChange}
                />
              </>
            )}
            {showYearsFilter > 0 && (
              <>
                <h2 className="is-size-6 mt-5 has-text-weight-extra-bold">
                  Year
                </h2>
                <YearInput
                  currentRange={currentYears}
                  onChange={this.handleYearChange}
                />
              </>
            )}
            {showNewlyListed &&
              <Field
                showErrors={false}
                label={'Newly Listed'}
                checked={newlyListed}
                type="checkbox"
                id="newlyListed"
                name="newlyListed"
                checkedReturn={'boolean'}
                onChange={({ checked }) => this.handleNewlyListed(checked)}
              />
            }
            {showTwentyPointInspected &&
              <Field
                showErrors={false}
                label={'20-Point Inspected'}
                checked={twentyPointInspected}
                type="checkbox"
                id="twentyPointInspected"
                name="twentyPointInspected"
                checkedReturn={'boolean'}
                onChange={({ checked }) => this.handleTwentyPointInspected(checked)}
              />
            }
            {showBikeForSale && (
              <Field
                showErrors={false}
                label={'Only show motorcycles for sale'}
                checked={isBikeForSale}
                type="checkbox"
                id="isBikeForSale"
                name="isBikeForSale"
                checkedReturn={'boolean'}
                onChange={({ checked }) => this.handleIsBikeForSale(checked)}
              />
            )}
          </div><br/><br/>
          {showFooterMessage &&
            <div className='more-filte-bottom-float-container'>
              <div className="more-filte-bottom-float">
                <div className={`has-text-right search-filter-apply-btn mb-0`}>
                  <Button
                    onClick={this.handleApply}
                    style={{ marginBottom: 0 }}
                    disabled={disableApplyBtn}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          }
        </>
      </SearchFilterPopUp>
    )
  }
}

export default withRouter(MoreFilters)

MoreFilters.defaultProps = {
  defaultLabel: 'More Filters',
  currentYears: [yearDefault[0], yearDefault[1]],
  currentEngines: [engineDefault[0], engineDefault[1]],
  currentPriceRange: [priceDefault[0], priceDefault[1]],
  currentSeatRange: [seatDefault[0], seatDefault[1]],
  distance: maxDistanceDefault,
  isBikeForSale: isBikeForSaleDefault,
  newlyListed: newlyListedDefault,
  twentyPointInspected: twentyPointInspectedDefault,
  showBikeForSale: true,
  showNewlyListed: true,
  showTwentyPointInspected: true,
  showYearsFilter: true,
  showDistanceFilter: true,
  showPriceFilter: true,
  showEngineFilter: true,
  showSeatFilter: true,
  showFooterMessage: true,
  onApply: function () { },
  onOpen: function () { },
  onClose: function () { },
  onClear: function () { },
  pushToUrl: true,
}
